export default __webpack_public_path__ + "977d21be875d1b65cf982c8c945ddd2c.xlf";